<main class="bg-white dark:bg-slate-900 min-h-screen flex flex-col">
    <!-- Hero Section -->
    <section class="relative w-full min-h-screen flex items-center justify-center overflow-hidden">

        <video autoplay muted loop playsinline class="absolute inset-0 w-full h-full object-cover">
            <source src="/0_Globalization_Technology_1920x1080.mp4" type="video/mp4" />
            Your browser does not support the video tag.
        </video>

        <div class="absolute inset-0 bg-black/50"></div>

        <div class="relative z-10 max-w-3xl mx-auto px-6 py-20 flex flex-col items-center text-center space-y-6">

            <h1 class="text-xl sm:text-4xl lg:text-5xl font-bold text-white font-arimo leading-tight">
                <span class="block">Empowering Technologies.</span>
                <span class="block text-[#E17A17]">Enabling Global Growth.</span>
            </h1>

            <p class="text-gray-200 text-base sm:text-lg font-poppins leading-relaxed max-w-2xl">
                Sriee Holdings is a premier global distribution partner, connecting groundbreaking emerging
                technologies with markets worldwide. We empower innovations to thrive by forging strategic
                partnerships across the globe.
            </p>

            <div class="flex flex-col sm:flex-row gap-4 justify-center">
                <a routerLink="/"
                    class="px-6 py-3 bg-[#E17A17] text-white font-medium rounded-lg shadow-md hover:bg-[#1D4BA6] hover:text-white transition">
                    Discover Our Sectors
                </a>
                <a routerLink="/partnership"
                    class="px-6 py-3 border border-white text-white font-medium rounded-lg hover:bg-white hover:text-[#1D4BA6] transition">
                    Explore a Partnership
                </a>
            </div>
        </div>
    </section>


    <!-- About Us Section -->
    <section id="about" class="relative bg-white py-20">
        <div class="max-w-7xl mx-auto px-6 lg:px-12">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative">

                <!-- Mobile Background Image -->
                <div class="absolute inset-0 opacity-15 lg:hidden">
                    <img src="/partnership.png"
                        alt="Team collaboration background" class="w-full h-full object-cover" />
                </div>

                <!-- Left Content -->
                <div class="space-y-6 text-center lg:text-left relative z-10">
                    <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1D4BA6]">
                        About Us
                    </h2>
                    <p class="text-gray-600 text-base sm:text-lg leading-relaxed font-poppins">
                        Through strategic partnerships with governments, corporations, and industry leaders,
                        we accelerate adoption of frontier technologies and transform innovation into real impact.
                    </p>
                    <p class="text-gray-600 text-base sm:text-lg leading-relaxed font-poppins">
                        We don’t just bring technology to market —
                        <span class="text-[#E17A17] font-semibold">we ensure it thrives.</span>
                    </p>
                    <a routerLink="/about"
                        class="inline-block mt-4 px-6 py-3 bg-[#E17A17] text-white font-medium rounded-lg shadow-md hover:bg-[#1D4BA6] hover:text-white transition">
                        Learn More
                    </a>
                </div>

                <!-- Right Illustration (Desktop Only) -->
                <div class="hidden lg:flex justify-center lg:justify-end">
                    <img src="/partnership.png"
                        alt="Team collaboration illustration"
                        class="w-3/4 sm:w-2/3 lg:w-full max-w-md object-contain drop-shadow-xl" loading="lazy" />
                </div>
            </div>
        </div>
    </section>


    <!-- Emerging Sectors Section -->
    <section id="sectors" class="relative bg-gray-100 dark:bg-slate-800 py-20">
        <div class="max-w-7xl mx-auto px-6 lg:px-12">
            <!-- Heading -->
            <div class="text-center mb-16">
                <h2
                    class="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1D4BA6] dark:text-white relative inline-block after:content-[''] after:block after:w-20 after:h-1 after:bg-[#1D4BA6] after:mx-auto after:mt-4">
                    Emerging Sectors
                </h2>
                <p class="text-gray-600 dark:text-gray-300 mt-6 max-w-2xl mx-auto text-lg">
                    Exploring the frontier industries driving the next wave of innovation and transformation.
                </p>
            </div>

            <!-- Cards Grid -->
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
                <div *ngFor="let sector of sectors"
                    class="group bg-white dark:bg-slate-900 rounded-2xl shadow-lg overflow-hidden relative hover:shadow-2xl hover:-translate-y-2 transition-all duration-300">

                    <!-- Icon -->
                    <div class="p-6 flex items-center justify-left">
                        <div class="flex items-center justify-center text-3xl  text-white">
                            {{ sector.icon }}
                        </div>
                    </div>

                    <!-- Content -->
                    <div class="px-6 pb-6 text-left">
                        <h3 class="text-xl font-semibold mb-3 text-[#1D4BA6] dark:text-white">
                            {{ sector.title }}
                        </h3>
                        <p class="text-gray-600 dark:text-gray-400 text-sm leading-relaxed mb-4">
                            {{ sector.description }}
                        </p>
                        <a href="#" class=" text-[#E17A17] font-medium text-sm  hover:text-[#1D4BA6] transition">
                            Learn More →
                        </a>
                    </div>

                    <!-- Gradient Border on Hover -->
                    <div
                        class="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-[#1D4BA6] transition-all duration-300 pointer-events-none">
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- What We Deliver Section -->
    <section id="deliver" class="relative bg-[#1D4BA6] py-20 text-white">
        <div class="absolute inset-0 opacity-20 bg-center bg-cover" style="background-image: url('/world-map.png');">
        </div>

        <div class="relative max-w-7xl mx-auto px-6 lg:px-12">
            <div class="text-center mb-12">
                <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold">
                    What We Deliver?<br />
                    <span class="text-[#E17A17]">(Core Services)</span>
                </h2>
                <p class="mt-4 text-lg sm:text-xl max-w-3xl mx-auto text-gray-200 italic">
                    From Innovation to Worldwide Adoption — Transforming your vision into global impact
                </p>
            </div>

            <!-- Cards Grid -->
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                <div class="bg-[#E17A17] border-2 border-white text-[#1D4BA6] rounded-2xl shadow-lg p-6 flex flex-col">
                    <div class="text-4xl mb-4">🌍</div>
                    <h3 class="text-xl font-semibold mb-2">Global Distribution & Market Expansion</h3>
                    <p class="flex-1">
                        Leverage our extensive global network and logistics expertise to bring your product to
                        new customers in multiple countries, expanding your brand's international footprint.
                    </p>
                </div>

                <div class="bg-[#1D4BA6] border-2 border-white rounded-2xl shadow-lg p-6 flex flex-col">
                    <div class="text-4xl mb-4 text-[#E17A17]">🤝</div>
                    <h3 class="text-xl font-semibold mb-2 text-white">Strategic Connections</h3>
                    <p class="text-gray-300 flex-1">
                        We open doors to key opportunities by connecting your technology with trusted
                        decision-makers in governments, corporations, and industry-leading enterprises.
                    </p>
                </div>

                <div class="bg-[#E17A17] border-2 border-white text-[#1D4BA6] rounded-2xl shadow-lg p-6 flex flex-col">
                    <div class="text-4xl mb-4">🎯</div>
                    <h3 class="text-xl font-semibold mb-2">Customer Acquisition</h3>
                    <p class="flex-1">
                        Our on-the-ground market expertise and targeted outreach strategies help you identify,
                        engage, and acquire customers across international markets, driving sales and revenue.
                    </p>
                </div>

                <div class="bg-[#1D4BA6] border-2 border-white rounded-2xl shadow-lg p-6 flex flex-col">
                    <div class="text-4xl mb-4 text-[#E17A17]">📈</div>
                    <h3 class="text-xl font-semibold mb-2 text-white">Scalable Growth</h3>
                    <p class="text-gray-300 flex-1">
                        We provide a clear pathway for your technology's growth, ensuring it can scale effectively
                        and sustainably to meet the demands of a global market.
                    </p>
                </div>
            </div>
        </div>
    </section>

    <!-- Why Sriee Holdings Section with Parallax -->
    <section id="why" class="relative bg-fixed bg-center bg-cover py-32 text-white"
        style="background-image: url('/69450352_23_689.jpg');">

        <div class="absolute inset-0 bg-black bg-opacity-10"></div>

        <div class="relative max-w-4xl mx-auto px-6 text-center">
            <div
                class="flex justify-center mb-10 opacity-0 transform scale-75 transition-all duration-1000 ease-out logo-animate">

                <div class="flip-container w-32 h-32 md:w-48 md:h-48">
                    <div class="flip-inner">
                        <div class="flip-front">
                            <img src="/logo-thumbnail-v2.png" alt="Sriee Holdings Logo"
                                class="w-full h-full object-contain " />
                        </div>
                    </div>
                </div>

            </div>

            <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 text-[#1D4BA6]">
                Why Sriee Holdings?
            </h2>
            <p class="text-lg sm:text-xl leading-relaxed text-gray-600">
                We are more than a distribution partner; we are a strategic extension of your team.
                With a proven global network and deep industry expertise, we transform innovation into impact,
                ensuring that emerging technologies don’t just reach the market, but thrive worldwide.
            </p>
        </div>
    </section>


    <!-- Partnerships & Network Section -->
    <section id="partnership"
        class="relative bg-gradient-to-b from-gray-50 to-white dark:from-slate-800 dark:to-slate-900 py-20">
        <div class="max-w-7xl mx-auto px-6 lg:px-12 text-center">

            <!-- Heading -->
            <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1D4BA6] dark:text-white">
                Partnerships & Network
            </h2>
            <div class="w-24 h-1 bg-[#E17A17] mx-auto mt-3 rounded"></div>
            <p class="mt-4 text-lg sm:text-xl text-gray-600 dark:text-gray-300">
                Trusted by Leading Innovators
            </p>

            <!-- Logos Grid -->
            <div
                class="mt-12 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-10 items-center justify-center">
                <!-- Example Logos -->
                <div class="p-4 bg-white dark:bg-slate-800 rounded-xl shadow-md hover:shadow-xl transition">
                    <img src="/partners-logos/partner1.svg" alt="Partner 1"
                        class="h-20 object-contain mx-auto grayscale hover:grayscale-0 hover:scale-110 transition duration-300" />
                </div>
                <div class="p-4 bg-white dark:bg-slate-800 rounded-xl shadow-md hover:shadow-xl transition">
                    <img src="/partners-logos/partner2.svg" alt="Partner 2"
                        class="h-24 object-contain mx-auto grayscale hover:grayscale-0 hover:scale-110 transition duration-300" />
                </div>
                <div class="p-4 bg-white dark:bg-slate-800 rounded-xl shadow-md hover:shadow-xl transition">
                    <img src="/partners-logos/partner3.svg" alt="Partner 3"
                        class="h-20 object-contain mx-auto grayscale hover:grayscale-0 hover:scale-110 transition duration-300" />
                </div>
                <div class="p-4 bg-white dark:bg-slate-800 rounded-xl shadow-md hover:shadow-xl transition">
                    <img src="/partners-logos/partner4.svg" alt="Partner 4"
                        class="h-24 object-contain mx-auto grayscale hover:grayscale-0 hover:scale-110 transition duration-300" />
                </div>
                <div class="p-4 bg-white dark:bg-slate-800 rounded-xl shadow-md hover:shadow-xl transition">
                    <img src="/partners-logos/partner5.png" alt="Partner 5"
                        class="h-24 object-contain mx-auto grayscale hover:grayscale-0 hover:scale-110 transition duration-300" />
                </div>
                <div class="p-4 bg-white dark:bg-slate-800 rounded-xl shadow-md hover:shadow-xl transition">
                    <img src="/partners-logos/partner6.png" alt="Partner 6"
                        class="h-24 object-contain mx-auto grayscale hover:grayscale-0 hover:scale-110 transition duration-300" />
                </div>
            </div>
        </div>
    </section>


    <!-- Global Presence Section -->
    <section id="presence" class="relative bg-gray-50 dark:bg-slate-900 py-20">
        <div class="max-w-7xl mx-auto px-6 text-center">
            <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#E17A17] dark:text-white mb-4">
                Global Presence
            </h2>
            <p class="text-lg sm:text-xl text-gray-700 dark:text-gray-300 mb-5">
                Empowering Technology. Enabling Global Growth.
            </p>

            <!-- Map Container -->
            <div class="relative w-full max-w-6xl mx-auto">
                <img src="/blue-map.png" alt="World Map" class="w-full" />

                <!-- Hotspot Example: North America -->
                <div class="absolute top-[30%] left-[20%] flex flex-col items-left lg:flex-row lg:items-center">
                    <!-- Dot -->
                    <div class="w-4 h-4 bg-[#E17A17] rounded-full border-2 border-white shadow-md animate-pulse"></div>

                    <!-- Label -->
                    <div
                        class="mt-2 lg:mt-0 lg:ml-2 bg-[#E17A17] text-[#1D4BA6] text-xs sm:text-sm rounded-lg px-2 py-1 shadow-md">
                        North America
                    </div>
                </div>

                <!-- Hotspot: Europe -->
                <div class="absolute top-[28%] left-[50%] flex flex-col items-left lg:flex-row lg:items-center">
                    <div class="w-4 h-4 bg-[#E17A17] rounded-full border-2 border-white shadow-md animate-pulse"></div>
                    <div
                        class="mt-2 lg:mt-0 lg:ml-2 bg-[#E17A17] text-[#1D4BA6] text-xs sm:text-sm rounded-lg px-2 py-1 shadow-md">
                        Europe
                    </div>
                </div>

                <!-- Hotspot: Asia -->
                <div class="absolute top-[35%] left-[70%] flex flex-col items-left lg:flex-row lg:items-center">
                    <div class="w-4 h-4 bg-[#E17A17] rounded-full border-2 border-white shadow-md animate-pulse"></div>
                    <div
                        class="mt-2 lg:mt-0 lg:ml-2 bg-[#E17A17] text-[#1D4BA6] text-xs sm:text-sm rounded-lg px-2 py-1 shadow-md">
                        Asia
                    </div>
                </div>

                <!-- Hotspot: Middle East -->
                <div class="absolute top-[42%] left-[58%] flex flex-col items-left lg:flex-row lg:items-center">
                    <div class="w-4 h-4 bg-[#E17A17] rounded-full border-2 border-white shadow-md animate-pulse"></div>
                    <div
                        class="mt-2 lg:mt-0 lg:ml-2 bg-[#E17A17] text-[#1D4BA6] text-xs sm:text-sm rounded-lg px-2 py-1 shadow-md">
                        Middle East
                    </div>
                </div>

                <!-- Hotspot: Africa -->
                <div class="absolute top-[55%] left-[50%] flex flex-col items-left lg:flex-row lg:items-center">
                    <div class="w-4 h-4 bg-[#E17A17] rounded-full border-2 border-white shadow-md animate-pulse"></div>
                    <div
                        class="mt-2 lg:mt-0 lg:ml-2 bg-[#E17A17] text-[#1D4BA6] text-xs sm:text-sm rounded-lg px-2 py-1 shadow-md">
                        Africa
                    </div>
                </div>

                <!-- Hotspot: Australia -->
                <div class="absolute top-[70%] left-[80%] flex flex-col items-left lg:flex-row lg:items-center">
                    <div class="w-4 h-4 bg-[#E17A17] rounded-full border-2 border-white shadow-md animate-pulse"></div>
                    <div
                        class="mt-2 lg:mt-0 lg:ml-2 bg-[#E17A17] text-[#1D4BA6] text-xs sm:text-sm rounded-lg px-2 py-1 shadow-md">
                        Australia
                    </div>
                </div>
            </div>

        </div>
    </section>


    <!-- Call-to-Action Section -->
    <section id="contact" class="relative bg-[#1D4BA6] text-white py-20">
        <div class="max-w-7xl mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12">

            <!-- Left Content -->
            <div class="flex flex-col justify-center">
                <h2 class="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">
                    Let’s Transform Innovation into Global Impact.
                </h2>
                <p class="text-lg sm:text-xl text-gray-200 mb-8">
                    Ready to scale your innovation to global markets? Partner with us today.
                </p>

                <!-- Contact Details -->
                <div class="space-y-4 text-gray-200">
                    <p><strong>Office:</strong> Registered Office (Singapore HQ): 1 Raffles Place, <br /> #34-04 One
                        Raffles Place, Singapore 048616, Singapore</p>
                    <p><strong>Phone:</strong> +65 9113 0004 & 05 (Singapore line)</p>
                    <p><strong>Email:</strong> info&#64;srieeholdings.sg</p>
                </div>

                <!-- Buttons -->
                <div class="mt-8 flex flex-wrap gap-4">
                    <!-- Contact button -->
                    <button type="button" (click)="toggleForm('contact')"
                        [ngClass]="!showWorkWithUs ? 'bg-[#E17A17] text-[#1D4BA6] shadow-md' : 'border border-[#E17A17] text-[#E17A17] bg-transparent hover:bg-[#E17A17] hover:text-[#1D4BA6]'"
                        class="px-6 py-3 font-semibold rounded-lg transition">
                        Contact
                    </button>

                    <!-- Work With Us button -->
                    <button type="button" (click)="toggleForm('work')"
                        [ngClass]="showWorkWithUs ? 'bg-[#E17A17] text-[#1D4BA6] shadow-md' : 'border border-[#E17A17] text-[#E17A17] bg-transparent hover:bg-[#E17A17] hover:text-[#1D4BA6]'"
                        class="px-6 py-3 font-semibold rounded-lg transition">
                        Work With Us
                    </button>
                </div>


            </div>
            <!-- ===================== CONTACT FORM ===================== -->
            <div *ngIf="!showWorkWithUs" class="bg-white rounded-2xl shadow-xl p-8 text-gray-800 mt-6">
                <h3 class="text-2xl font-bold text-[#1D4BA6] mb-6">Contact Us</h3>

                <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="space-y-5">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                        <!-- Full Name -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Full Name</label>
                            <input formControlName="name" type="text" placeholder="Enter your full name"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]" />
                            <p *ngIf="submitted && fContact['name'].errors" class="text-red-500 text-sm mt-1">
                                <span *ngIf="fContact['name'].errors['required']">Name is required.</span>
                                <span *ngIf="fContact['name'].errors['minlength']">Name must be at least 2
                                    characters.</span>
                            </p>
                        </div>

                        <!-- Organization -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Organization</label>
                            <input formControlName="company" type="text" placeholder="Enter your organization"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]" />
                        </div>

                        <!-- Email -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Email Address</label>
                            <input formControlName="email" type="email" placeholder="Enter your email"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]" />
                            <p *ngIf="submitted && fContact['email'].errors" class="text-red-500 text-sm mt-1">
                                <span *ngIf="fContact['email'].errors['required']">Email is required.</span>
                                <span *ngIf="fContact['email'].errors['email']">Enter a valid email.</span>
                            </p>
                        </div>

                        <!-- Phone -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Phone</label>
                            <input formControlName="phone" type="text" placeholder="Optional"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]" />
                        </div>

                        <!-- Country -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Country / Region</label>
                            <input formControlName="country" type="text" placeholder="Enter country"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]" />
                        </div>

                        <!-- Subject -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Subject</label>
                            <input formControlName="subject" type="text" placeholder="Short subject"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]" />
                        </div>
                    </div>

                    <!-- Message -->
                    <div>
                        <label class="block text-sm font-medium mb-1">Message</label>
                        <textarea formControlName="message" rows="3" placeholder="Enter your message"
                            class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]"></textarea>
                        <p *ngIf="submitted && fContact['message'].errors" class="text-red-500 text-sm mt-1">
                            <span *ngIf="fContact['message'].errors['required']">Message is required.</span>
                            <span *ngIf="fContact['message'].errors['minlength']">At least 10 characters
                                required.</span>
                            <span *ngIf="fContact['message'].errors['maxlength']">Max 300 characters allowed.</span>
                        </p>
                    </div>

                    <button type="submit"
                        class="w-full bg-[#1D4BA6] text-white font-semibold py-3 rounded-lg shadow-md hover:bg-[#E17A17] hover:text-[#1D4BA6] transition">
                        Send Message
                    </button>
                </form>
            </div>

            <!-- ===================== WORK WITH US FORM ===================== -->
            <div *ngIf="showWorkWithUs" class="bg-white rounded-2xl shadow-xl p-8 text-gray-800 mt-6">
                <h3 class="text-2xl font-bold text-[#1D4BA6] mb-6">Work With Us</h3>

                <form [formGroup]="workForm" (ngSubmit)="onSubmit()" class="space-y-5">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                        <!-- Full Name -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Full Name</label>
                            <input formControlName="fullName" type="text" placeholder="Enter your full name"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]" />
                            <p *ngIf="submitted && fWork['fullName'].errors" class="text-red-500 text-sm mt-1">
                                Full Name is required.
                            </p>
                        </div>

                        <!-- Organization -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Organization / Startup</label>
                            <input formControlName="organization" type="text" placeholder="Enter organization"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]" />
                            <p *ngIf="submitted && fWork['organization'].errors" class="text-red-500 text-sm mt-1">
                                Organization is required.
                            </p>
                        </div>

                        <!-- Email -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Email Address</label>
                            <input formControlName="email" type="email" placeholder="Enter email"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]" />
                            <p *ngIf="submitted && fWork['email'].errors" class="text-red-500 text-sm mt-1">
                                <span *ngIf="fWork['email'].errors['required']">Email is required.</span>
                                <span *ngIf="fWork['email'].errors['email']">Enter a valid email.</span>
                            </p>
                        </div>

                        <!-- Phone -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Phone / WhatsApp</label>
                            <input formControlName="phone" type="text" placeholder="+91 98765 43210"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]" />
                        </div>

                        <!-- Country -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Country / Region</label>
                            <input formControlName="country" type="text" placeholder="Enter country"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]" />
                        </div>

                        <!-- Website -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Website / LinkedIn</label>
                            <input formControlName="website" type="url" placeholder="https://example.com"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]" />
                        </div>

                        <!-- Sector -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Technology Sector</label>
                            <select formControlName="sector"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]">
                                <option value="">Select sector</option>
                                <option>SpaceTech</option>
                                <option>Clean Energy</option>
                                <option>Quantum</option>
                                <option>MedTech</option>
                            </select>
                        </div>

                        <!-- Stage -->
                        <div>
                            <label class="block text-sm font-medium mb-1">Stage of Development</label>
                            <select formControlName="stage"
                                class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]">
                                <option value="">Select stage</option>
                                <option>Prototype</option>
                                <option>Pilot</option>
                                <option>Commercial</option>
                                <option>Scaling</option>
                            </select>
                        </div>
                    </div>

                    <!-- Description -->
                    <div>
                        <label class="block text-sm font-medium mb-1">Brief Description</label>
                        <textarea formControlName="description" rows="3" placeholder="Describe your technology/product"
                            class="w-full border rounded-lg px-4 py-3 focus:ring-2 focus:ring-[#E17A17]"></textarea>
                    </div>

                    <!-- Partnership Interests -->
                    <div class="space-y-2">
                        <p class="text-sm font-medium">Partnership Interests</p>
                        <div class="flex flex-wrap gap-4">
                            <label><input type="checkbox" formControlName="distribution" /> Distribution</label>
                            <label><input type="checkbox" formControlName="investment" /> Investment</label>
                            <label><input type="checkbox" formControlName="govtAccess" /> Government Access</label>
                            <label><input type="checkbox" formControlName="jointDev" /> Joint Development</label>
                        </div>
                    </div>

                    <!-- Upload -->
                    <div>
                        <label class="block text-sm font-medium mb-1">Upload Pitch Deck / Brochure</label>
                        <input type="file" formControlName="file" class="w-full border rounded-lg px-4 py-3" />
                    </div>

                    <button type="submit"
                        class="w-full bg-[#1D4BA6] text-white font-semibold py-3 rounded-lg shadow-md hover:bg-[#E17A17] hover:text-[#1D4BA6] transition">
                        Submit Proposal
                    </button>
                </form>
            </div>

        </div>
    </section>




</main>

<!-- Go To Top Button -->
<button *ngIf="showGoToTop" (click)="scrollToTop()" class="fixed bottom-6 right-6 bg-[#E17A17] text-white px-3 py-2 rounded-full shadow-lg 
         hover:bg-[#1D4BA6] transition z-50 text-2xl" aria-label="Go to top">
    ⬆
</button>